import { createApp, h } from 'vue'

const TYPE_STYLE = {
    success: {
        wrap: 'border-emerald-200 bg-emerald-50 text-emerald-950',
        accent: 'bg-emerald-500',
        icon: 'text-emerald-600',
        close: 'text-emerald-700/50 hover:bg-emerald-100 hover:text-emerald-900'
    },
    danger: {
        wrap: 'border-red-200 bg-red-50 text-red-950',
        accent: 'bg-red-500',
        icon: 'text-red-600',
        close: 'text-red-700/50 hover:bg-red-100 hover:text-red-900'
    },
    error: {
        wrap: 'border-red-200 bg-red-50 text-red-950',
        accent: 'bg-red-500',
        icon: 'text-red-600',
        close: 'text-red-700/50 hover:bg-red-100 hover:text-red-900'
    },
    warning: {
        wrap: 'border-amber-200 bg-amber-50 text-amber-950',
        accent: 'bg-amber-500',
        icon: 'text-amber-600',
        close: 'text-amber-700/50 hover:bg-amber-100 hover:text-amber-900'
    },
    info: {
        wrap: 'border-sky-200 bg-sky-50 text-sky-950',
        accent: 'bg-sky-500',
        icon: 'text-sky-600',
        close: 'text-sky-700/50 hover:bg-sky-100 hover:text-sky-900'
    },
    default: {
        wrap: 'border-slate-200 bg-white text-slate-900',
        accent: 'bg-slate-400',
        icon: 'text-slate-500',
        close: 'text-slate-400 hover:bg-slate-100 hover:text-slate-700'
    }
}

const ICON_CLASS = {
    success: 'fa fa-check-circle',
    danger: 'fa fa-exclamation-circle',
    error: 'fa fa-exclamation-circle',
    warning: 'fa fa-exclamation-triangle',
    info: 'fa fa-info-circle',
    default: 'fa fa-info-circle'
}

let host = null
let seed = 0

function ensureHost () {
    if (host) return host
    const el = document.createElement('div')
    el.id = 'b-notify-host'
    document.body.appendChild(el)

    const app = createApp({
        data () {
            return { items: [] }
        },
        methods: {
            push (item) {
                this.items.push(item)
                if (item.duration > 0) {
                    setTimeout(() => this.remove(item.id), item.duration)
                }
            },
            remove (id) {
                this.items = this.items.filter(i => i.id !== id)
            }
        },
        render () {
            return h('div', {
                class: 'pointer-events-none fixed right-4 top-4 z-[100] flex w-[22rem] max-w-[calc(100vw-2rem)] flex-col gap-3'
            }, this.items.map(item => {
                const style = TYPE_STYLE[item.type] || TYPE_STYLE.default
                return h('div', {
                    key: item.id,
                    role: 'status',
                    class: [
                        'pointer-events-auto relative overflow-hidden rounded-xl border shadow-md b-notify-enter',
                        style.wrap
                    ].join(' ')
                }, [
                    h('div', { class: ['absolute inset-y-0 left-0 w-1', style.accent].join(' ') }),
                    h('div', { class: 'flex items-start gap-3 py-3 pl-4 pr-3' }, [
                        h('i', {
                            class: [
                                'mt-0.5 shrink-0 text-base leading-none',
                                ICON_CLASS[item.type] || ICON_CLASS.default,
                                style.icon
                            ].join(' '),
                            'aria-hidden': 'true'
                        }),
                        item.html
                            ? h('div', { class: 'min-w-0 flex-1 pr-1 pt-0.5 text-sm leading-5', innerHTML: item.content })
                            : h('div', { class: 'min-w-0 flex-1 pr-1 pt-0.5 text-sm leading-5' }, item.content),
                        h('button', {
                            type: 'button',
                            'aria-label': 'Close',
                            class: [
                                'inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md',
                                'transition-colors',
                                style.close
                            ].join(' '),
                            onClick: () => this.remove(item.id)
                        }, [
                            h('i', {
                                class: 'fa fa-times text-xs leading-none',
                                'aria-hidden': 'true'
                            })
                        ])
                    ])
                ])
            }))
        }
    })
    host = app.mount(el)

    if (!document.getElementById('b-notify-style')) {
        const style = document.createElement('style')
        style.id = 'b-notify-style'
        style.textContent = `
.b-notify-enter {
  animation: b-notify-in 180ms ease-out;
}
@keyframes b-notify-in {
  from { opacity: 0; transform: translateY(-6px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}`
        document.head.appendChild(style)
    }

    return host
}

export function notify (options = {}) {
    const hst = ensureHost()
    const duration = options.duration === 0 ? 0 : (options.duration == null ? 10000 : options.duration)
    hst.push({
        id: ++seed,
        type: options.type || 'info',
        content: options.content || options.message || '',
        html: !!options.html,
        duration
    })
}

export default {
    install (app) {
        app.config.globalProperties.$b_notify = notify
    }
}
